export const UPDATE_LIVESTREAMS = 'UPDATE_LIVESTREAMS';
export const EVENT_HAS_TIIVII_OTT_CONFIG = 'EVENT_HAS_TIIVII_OTT_CONFIG';
export const STORE_DEPLOYMENT_SOURCES = 'STORE_DEPLOYMENT_SOURCES';
export const EVENT_HAS_TIIVII_RTMP_CONFIG = 'EVENT_HAS_TIIVII_RTMP_CONFIG';
export const EVENT_SHOW_DELETED = 'EVENT_SHOW_DELETED';
export const EVENT_NEW_SHIELD_ASSET_TEAM1 = 'EVENT_NEW_SHIELD_ASSET_TEAM1';
export const EVENT_NEW_SHIELD_ASSET_TEAM2 = 'EVENT_NEW_SHIELD_ASSET_TEAM2';
export const STORE_EVENT_TO_COPY = 'STORE_EVENT_TO_COPY';

export const STORE_CUSTOMERS = 'STORE_CUSTOMERS';
export const STORE_CONTRACTS = 'STORE_CONTRACTS';
